import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import style from "./style.module.scss";
export default function Button(props) {
    const { type = "button", variation = "secondary", children, className, id, linkMode, urlPath, disabled, large, title, } = props;
    /** Setup the event listeners to track mouse movement so we can see where they want to drag the thumb to. */
    function onClick(event) {
        if (props.onClick) {
            props.onClick(event);
        }
    }
    //Add styles based on type.
    const styles = [];
    switch (variation) {
        case "primary":
            styles.push(style["button--primary"], style["button"]);
            break;
        case "tertiary":
            styles.push(style["button--tertiary"], style["button"]);
            break;
        case "link":
            styles.push(style["button--link"], style["button"]);
            break;
        case "none":
            styles.push(style["button--none"], style["button"]);
            break;
        case "primary-inline":
            styles.push(style["button--primary"], style["button"], style["button--link-style"]);
            break;
        case "secondary-inline":
            styles.push(style["button--secondary"], style["button"], style["button--link-style"]);
            break;
        case "tertiary-inline":
            styles.push(style["button--tertiary"], style["button"], style["button--link-style"]);
            break;
        case "inverse-secondary":
            styles.push(style["button--inverse-secondary"], style["button"]);
            break;
        default:
            styles.push(style["button--secondary"], style["button"]);
            break;
    }
    if (large) {
        styles.push(style["button--large"]);
    }
    if (disabled) {
        styles.push(style["button--disabled"]);
    }
    if (linkMode) {
        return (_jsx("a", { className: classNames(style["button__link"], styles, className), style: props.style, href: urlPath, title: title, children: children }));
    }
    return (_jsx("button", { type: type, className: classNames(styles, className), style: props.style, onClick: onClick, disabled: disabled, id: id, title: title, children: children })
    /* eslint-enable react/button-has-type */
    );
}
